import { useState } from "react";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified) return null;
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      const msg = { sent: "Bestätigungs-E-Mail gesendet", not_configured: "E-Mail-Versand ist nicht konfiguriert – bitte Admin kontaktieren", failed: "Versand fehlgeschlagen", already_verified: "Bereits bestätigt" }[data.email_status];
      data.email_status === "sent" ? toast.success(msg) : toast.error(msg);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 border-b border-amber-500/20 bg-amber-500/10 px-4 py-2 text-sm text-amber-200 sm:px-8" data-testid="verify-banner">
      <MailWarning className="h-4 w-4" /> Bitte bestätige deine E-Mail-Adresse ({user.email}).
      <button onClick={resend} disabled={busy} data-testid="verify-resend-button" className="underline underline-offset-2">Link erneut senden</button>
    </div>
  );
};
